import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="border-b border-line bg-surface/40" data-id="element-27" data-mp="vtfjgwgyi5h2">
      <div className="mx-auto max-w-3xl px-4 py-8 sm:py-10" data-id="element-28" data-mp="qu2xedxwt2fj">
        <SectionHeader id="bonos" title="5 Bonos incluidos" description="Y además recibes 5 recursos prácticos — GRATIS con tu compra." data-id="element-29" data-mp="qsi1ajvy5bfk" />
        <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-30" data-mp="ztq0d46aegap">
          {bonuses.map((b, i) => <li key={b.title} className={`flex flex-col rounded-xl border border-dashed border-accent/50 bg-surface p-3.5 ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-31" data-mp="1eicej2k6h20c" data-mpi={i}>
              <p className="flex items-center gap-1.5 font-display text-[0.7rem] font-bold uppercase text-accent" data-id="element-32" data-mp="1nhpso8j8yere">
                <GiftIcon size={13} aria-hidden="true" data-id="element-33" data-mp="3pqliqy5nl26a" />
                Bono {i + 1} — Gratis
              </p>
              <h3 className="mt-1 font-display text-sm font-extrabold text-ink" data-id="element-34" data-mp="3trdupz5wtl69">{b.title}</h3>
              <p className="mt-1 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-35" data-mp="2l2ycgbuh8l9">{b.desc}</p>
              <p className="mt-auto pt-2 text-xs font-medium text-muted" data-id="element-36" data-mp="7kfg4mnuzpgz">
                Valor: <span className="text-danger line-through" data-id="element-37" data-mp="cjs5be27d8mq">{b.value}</span>
              </p>
            </li>)}
        </ul>
        <div className="mt-4 rounded-xl border-2 border-accent bg-accent/10 p-3 text-center" data-id="element-38" data-mp="gklra1w34dcz">
          <p className="font-display text-sm font-extrabold text-ink sm:text-base" data-id="element-39" data-mp="lbu1v195i4rq">
            💰 Valor total de los 5 bonos: <span className="text-accent" data-id="element-40" data-mp="qa5f7lynmxep">{BONUS_TOTAL}</span>
          </p>
          <p className="mt-0.5 font-display text-sm font-extrabold text-success" data-id="element-41" data-mp="vatc2o9ke8gu">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}